module.exports = __webpack_public_path__ + "img/header-memoireRingsRedgold@2x.7960c79.webp";